// NavItem.jsx - Enhanced version
import { Box, ListItem, ListItemIcon, Typography } from '@mui/material';
import React from 'react';
import { NavIconButton } from './NavIconButton';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const NavItem = ({ item, isActive, open, drawerToggle }) => {
  const navigate = useNavigate();
  const startupDetails = useSelector((state) => state?.startupDetails?.data);

  return (
    !!item?.permission && (
      <ListItem
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          padding: '0.2rem 0.5rem',
          flexDirection: 'row',
          width: '100%',
          marginBottom: '0.25rem',
        }}
        disabled={item?.disabled}
        onClick={() => {
          !item?.disabled && navigate(item?.path);
        }}
      >
        <Box
          className={`${item?.hasRipple ? "rainbow" : ""}`}
          sx={{
            border: 'none',
            borderRadius: '9px',
            padding: '0.3rem 0.3rem',
            width: 'calc(100% - 20px)',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            backgroundColor: isActive
              ? 'rgba(255, 255, 255, 0.14)'
              : 'transparent',
            backdropFilter: isActive ? 'blur(10px)' : 'none',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            cursor: item?.disabled ? 'not-allowed' : 'pointer',
            position: 'relative',
            overflow: 'hidden',

            // Enhanced hover effects
            '&:hover': {
              // backgroundColor: isActive
              //   ? 'rgba(255, 255, 255, 0.2)'
              //   : 'rgba(255, 255, 255, 0.08)',
              // borderColor: isActive
              //   ? 'primary.light'
              //   : 'rgba(255, 255, 255, 0.2)',
              transform: 'translateY(-2px)',
              boxShadow: isActive
                ? '0 8px 25px rgba(0, 0, 0, 0.15), 0 0 20px rgba(255, 255, 255, 0.1)'
                : '0 4px 15px rgba(0, 0, 0, 0.1)',

              // Glow effect for active items
              '&::before': isActive
                ? {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background:
                      'linear-gradient(45deg, rgba(255,255,255,0.1), transparent)',
                    // borderRadius: '12px',
                    pointerEvents: 'none',
                  }
                : {},
            },

            // Active state enhancements
            // ...(isActive && {
            //   background:
            //     'linear-gradient(135deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1))',
            //   boxShadow:
            //     '0 4px 20px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
            // }),

            // Disabled state
            // ...(item?.disabled && {
            //   opacity: 0.5,
            //   backgroundColor: 'rgba(255, 255, 255, 0.05)',
            //   '&:hover': {
            //     backgroundColor: 'rgba(255, 255, 255, 0.05)',
            //     transform: 'none',
            //     boxShadow: 'none',
            //   },
            // }),
          }}
        >
          {item?.disabled ? (
            <NavIconButton item={item} isActive={isActive} open={open} />
          ) : (
            <Link
              // to={item?.path}
              onClick={drawerToggle}
              style={{
                textDecoration: 'none',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <NavIconButton item={item} isActive={isActive} open={open} />
            </Link>
          )}

          {!open && (
            <Typography
              sx={{
                display: 'block',
                cursor: item?.disabled ? 'not-allowed' : 'pointer',
                marginTop: '0.25rem',
                transition: 'all 0.3s ease',
                fontWeight: isActive ? 700 : 500,
                color: isActive ? '#FFFFFF' : 'rgba(255, 255, 255, 0.92)',
                fontSize: '0.6rem',
                lineHeight: '0.8rem',
                textAlign: 'center',
                maxWidth: '100%',
                // overflow: 'hidden',
                // textOverflow: 'ellipsis',
                // whiteSpace: 'nowrap',

                // Text glow effect for active items
                ...(isActive && {
                  textShadow: '0 0 8px rgba(255, 255, 255, 0.3)',
                }),
              }}
            >
              {item?.title}
            </Typography>
          )}
        </Box>
      </ListItem>
    )
  );
};

export default NavItem;
